/* stylelint-disable CssSyntaxError */
<!-- eslint-disable vue/no-v-html -->
<!-- color-function-alias-notation -->
<template>
  <div v-if="searchResultsFor"
       class="utd-ai-query-prefill"
       :class="`utd-ai-query-prefill--${props.pageSource}`">
    <button class="utd-ai-query-prefill-pill ds1-inline-block"
            @click="handleAction"
            @keydown.enter="handleAction">
      <div class="utd-ai-query-prefill-pill-text">
        <span ref="pillTextRef" class="pill-text-body" v-html="searchResultsFor" />
      </div>
      <div class="ai-search-submit">
        <img :src="aiSearchSparkIcon" class="ai-search-spark" alt="ai-search-spark">
        <span>Ask Expert AI</span>
        <div class="ai-search-arrow-icon-container">
          <img :src="aiSearchArrowIcon" class="ai-search-arrow-icon" alt="ai-search-arrow-icon">
        </div>
      </div>
    </button>
  </div>
  <LoginRegisterModal ref="loginRegisterModal" />
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { safeDecodeHtmlUriComponent } from '_acaSrc/utility/http';
import LoginRegisterModal from '_acaSrc/components/login/LoginRegisterModal.vue';
import useExpertAiAction from '_acaSrc/composables/useExpertAiAction.composable';
import aiSearchSparkIcon from '~_acaAssets/utd-ai/utd-ai-spark.svg';
import aiSearchArrowIcon from '~_acaAssets/utd-ai/arrow-right.svg';

const props = defineProps({
    width: {
        type: Number,
        default: null
    },
    searchTerm: {
        type: String,
        default: null
    },
    pageSource: {
        type: String,
        default: null
    }
});

const loginRegisterModal = ref(null);
const pillTextRef = ref(null);
const truncatedSearchText = ref(null);
const { handleExpertAiAction } = useExpertAiAction();

const searchForText = computed(() => safeDecodeHtmlUriComponent(props.searchTerm));
const searchResultsFor = computed(() => {
    if (props.pageSource === 'topic') {
        return 'Apply this topic to a clinical scenario';
    } 
    if (props.pageSource === 'search') {
        const aiSearchText = 'Need guidance on';
        if (truncatedSearchText.value !== null) {
            return `${aiSearchText} <strong>"${truncatedSearchText.value}..."</strong>?`;
        } 
        else {
            return `${aiSearchText} <strong>"${searchForText.value}"</strong>?`;
        }
    }
    return '';
});

const xAiSearchTerm = computed(() => truncatedSearchText.value !== null ? 
    truncatedSearchText.value : searchForText.value);

const computeTruncation = async() => {
    if (!pillTextRef.value || props.pageSource === 'topic') {
        return;
    }
    truncatedSearchText.value = null;
    await nextTick();
    const el = pillTextRef.value;
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 24;
    const maxHeight = lineHeight * 3;
    const isClamped = () => el.scrollHeight > maxHeight;
    if (!isClamped()) {
        return;
    }
    const words = searchForText.value.split(' ');
    for (let i = words.length - 1; i >= 1; i--) {
        truncatedSearchText.value = words.slice(0, i).join(' ');
        await nextTick();
        if (!isClamped()) {
            break;
        }
    }
};

onMounted(computeTruncation);
watch(searchForText, computeTruncation);
watch(() => props.width, computeTruncation);

const handleAction = async(event) => {
    const uiElementName = `ai-query-prefill-${props.pageSource}`;
    const prompt = xAiSearchTerm.value;
    await handleExpertAiAction({
        event,
        uiElementName,
        loginRegisterModalRef: loginRegisterModal,
        prompt,
        queryParam: 'prompt'
    });
};
</script>

<style lang="less">
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';
@import (reference) '~_acaAssets/global/global.less';
@import (reference) '~_acaAssets/wkce/mixins.less';

.utd-ai-query-prefill {
  .ds1-mr-2();
  .ds1-pb-1();
  display: inline-block;
  font-size: 16px;
  font-family: 'Fira Sans', sans-serif;
  line-height: 24px;
  text-align: left;

  &--topic {
    .ds1-pb-4();
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100%;
  }

  &--search {
    .ds1-pb-2();
    .ds1-pl-2();
    .ds1-pr-2();
    max-width: 750px;
    width: v-bind("props.width ? props.width + 'px' : '100%'");
    box-sizing: border-box;

    .utd-ai-query-prefill-pill-text .pill-text-body {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .utd-ai-query-prefill-pill {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 8px;
    border-radius: 12px;
    padding: 8px 16px;
    border: none;
    margin: 0;
    text-align: left;
    /* stylelint-disable */   
    background-image:
      linear-gradient(
        to bottom,
        #F0EBE8 0%,
        rgba(246,241,237,0.96) 8%,
        rgba(246,241,237,0.86) 16%,
        rgba(246,241,237,0.72) 26%,
        rgba(246,241,237,0.56) 36%,
        rgba(246,241,237,0.38) 50%,
        rgba(246,241,237,0.20) 64%,
        rgba(246,241,237,0.08) 78%,
        rgba(246,241,237,0.02) 90%,
        rgba(246,241,237,0.00) 100%
      ),
      radial-gradient(120% 80% at 50% 0%,
        rgba(255,255,255,0.45) 0%,
        rgba(255,255,255,0.10) 35%,
        transparent 60%
      ),
      radial-gradient(90% 70% at 12% 82%, rgba(246,180,205,0.45) 0%, transparent 65%),
      radial-gradient(120% 80% at 28% 80%, rgba(190,185,245,0.35) 0%, transparent 68%),
      radial-gradient(130% 90% at 50% 82%, rgba(140,190,245,0.22) 0%, transparent 65%),
      radial-gradient(130% 80% at 78% 80%, rgba(180,245,215,0.40) 0%, transparent 68%),
      radial-gradient(110% 70% at 88% 84%, rgba(95,211,138,0.38) 0%, transparent 65%
    );    
    /* stylelint-enable */
    background-repeat: no-repeat;
    background-position:
      top center,  
      top center,
      12% 100%, 
      28% 100%,
      50% 100%, 
      78% 100%,
      88% 100%;
    background-size:
      100% 100%,
      100% 50%,
      100% 110px,
      100% 110px,
      100% 110px,
      100% 110px,
      100% 110px;
    box-sizing: border-box;
  }

  .utd-ai-query-prefill-pill-text {
    display: inline-flex;
    align-items: center;


  }

  .ai-search-submit {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0.16px;
    border: none;
    display: inline-grid;
    grid-auto-flow: column;
    align-self: stretch;
    justify-content: center;
    align-items: center;
    gap: @ds1-spacing-multiplier;
    white-space: nowrap;
    border-radius: 26px;
    background: @WKCE-WHITE;
    box-shadow: @DS1-BOX-SHADOW-RGBA;
    padding: 8px 16px;
  }

  .ai-search-arrow-icon-container {
    display: inline-flex;
    align-items: center;
  }

}

@media (min-width: 768px) {
  .utd-ai-query-prefill {
    &--search {
      .ds1-pr-0();
      padding-left: 10px;
      width: v-bind("props.width ? props.width + 'px' : 'auto'");
    }

    &--topic {
      width: auto;
      padding-left: 0;
      padding-right: 0;
      margin-left: -16px !important;
      margin-right: -16px !important;
      
      .utd-ai-query-prefill-pill {
        width: auto;
      }
    }

    .utd-ai-query-prefill-pill {
      display: inline-grid;
      grid-auto-flow: column;
      align-items: center;
      justify-content: space-between;
      gap: 25px;
      padding: 15px 24px;
      // This overly-complicated gradient will be reviewed at a later date
      /* stylelint-disable */
      background-color: #F0EBE8;         
      background-image:
        radial-gradient(30% 32% at 100% 0%,
          rgba(40,185,105,0.58) 0%,
          rgba(40,185,105,0.40) 22%,
          rgba(40,185,105,0.22) 48%,
          rgba(40,185,105,0.10) 66%,
          transparent 80%
        ),

        radial-gradient(48% 54% at 100% 0%,
          rgba(168,240,199,0.46) 0%,
          rgba(168,240,199,0.28) 32%,
          rgba(168,240,199,0.14) 60%,
          transparent 84%
        ),

        radial-gradient(56% 62% at 92% 8%,
          rgba(174,228,241,0.28) 0%,
          rgba(174,228,241,0.16) 40%,
          rgba(174,228,241,0.08) 64%,
          transparent 82%
        ),

        radial-gradient(62% 70% at 88% 16%,
          rgba(176,186,236,0.24) 0%,
          rgba(176,186,236,0.14) 42%,
          rgba(176,186,236,0.08) 66%,
          transparent 84%
        ),

        radial-gradient(66% 76% at 84% 22%,
          rgba(190,175,235,0.20) 0%,
          rgba(190,175,235,0.12) 46%,
          transparent 86%
        ),

        radial-gradient(40% 52% at 72% 10%,
          rgba(255,196,180,0.20) 0%,
          rgba(255,196,180,0.10) 44%,
          transparent 80%
        ),
        radial-gradient(36% 50% at 66% 12%,
          rgba(255,172,185,0.18) 0%,
          rgba(255,172,185,0.10) 46%,
          transparent 82%
        ),

        radial-gradient(120% 72% at 100% 100%,
          rgba(255,255,255,0.92) 0%,
          rgba(255,255,255,0.42) 44%,
          transparent 78%
        );
      /* stylelint-enable */
      background-repeat: no-repeat;
      background-position:
        right top,
        right top,
        right top,
        right top,
        right top,
        right top,
        right top, 
        right bottom;
      background-size:
        100% clamp(220px, 62%, 520px),
        100% clamp(220px, 62%, 520px),
        100% clamp(220px, 62%, 520px),
        100% clamp(220px, 62%, 520px),
        100% clamp(220px, 62%, 520px),
        100% clamp(220px, 62%, 520px),
        100% clamp(220px, 62%, 520px),
        100% clamp(220px, 62%, 520px);
    }

    .ai-search-submit {
      display: inline-flex;
      align-self: start;
      align-items: center;
      justify-content: unset;
    }

    .utd-ai-query-prefill-pill-text {
      padding: 10px;
    }
  }
}

@media (min-width: 1140px) {
  .utd-ai-query-prefill {
    &--topic {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
</style>